import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Button, Link, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import AuthLayout from "../../components/AuthLayout";

const useStyles = makeStyles(theme => ({
  form: {
    width: "100%",
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    minHeight: 48,
    fontWeight: 700
  },
  links: {
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    flexWrap: "wrap"
  }
}));

const ForgotPassword = () => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async event => {
    event.preventDefault();
    setLoading(true);

    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Si el correo existe, enviaremos un enlace de recuperación.");
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Recuperar contraseña"
      subtitle="Ingresa tu correo y te enviaremos un enlace para crear una nueva contraseña."
    >
      <form className={classes.form} noValidate onSubmit={handleSubmit}>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="email"
          label="Correo Electrónico"
          name="email"
          value={email}
          onChange={event => setEmail(event.target.value)}
          autoComplete="email"
          autoFocus
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          disabled={loading || !email.trim()}
        >
          Enviar enlace
        </Button>
        {sent && (
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Revisa tu correo. El enlace vence en 30 minutos.
          </Typography>
        )}
        <div className={classes.links}>
          <Link variant="body2" component={RouterLink} to="/login">
            Volver al login
          </Link>
        </div>
      </form>
    </AuthLayout>
  );
};

export default ForgotPassword;
